export interface MaintenanceTransaction {
  id: string;
  assetId: string;
  assetCode: string;  // From JOIN
  assetName: string;  // From JOIN
  reference: string;
  maintenanceDate: string;
  maintenanceType: MaintenanceType;
  net: number;
  tax: number;
  taxRate: number;
  gross: number;
  currency: string;
  supplierName?: string;
  supplierReference?: string;
  description?: string;
  notes?: string;
  workPerformed?: string;
  partsReplaced?: string;
  nextMaintenanceDate?: string;
  warrantyWork: boolean;
  createdBy: string;
  createdDate: string;
  modifiedBy?: string;
  modifiedDate?: string;
}

export type MaintenanceType = 
  | 'Repair' 
  | 'Service' 
  | 'Inspection' 
  | 'Upgrade' 
  | 'Calibration' 
  | 'Cleaning'
  | 'Replacement'
  | 'Other';

export const MAINTENANCE_TYPE_LABELS: Record<MaintenanceType, string> = {
  Repair: 'Repair',
  Service: 'Service',
  Inspection: 'Inspection',
  Upgrade: 'Upgrade',
  Calibration: 'Calibration',
  Cleaning: 'Cleaning',
  Replacement: 'Replacement',
  Other: 'Other',
};

// DTO for creating maintenance transactions (matches backend CreateMaintenanceTransactionDto)
// Uses camelCase to match ASP.NET Core's default JSON serialization
export interface CreateMaintenanceDto {
  assetId: string;
  reference: string;
  maintenanceDate: string;
  maintenanceType: string;
  net: number;
  taxRate: number;
  supplierName?: string;
  supplierReference?: string;
  description?: string;
  notes?: string;
  workPerformed?: string;
  partsReplaced?: string;
  nextMaintenanceDate?: string;
  warrantyWork: boolean;
}

// DTO for updating maintenance transactions (matches backend UpdateMaintenanceTransactionDto)
// Uses camelCase to match ASP.NET Core's default JSON serialization
export interface UpdateMaintenanceDto {
  reference: string;
  maintenanceDate: string;
  maintenanceType: string;
  net: number;
  taxRate: number;
  supplierName?: string;
  supplierReference?: string;
  description?: string;
  notes?: string;
  workPerformed?: string;
  partsReplaced?: string;
  nextMaintenanceDate?: string;
  warrantyWork: boolean;
}

export interface MaintenanceSummary {
  totalGross: number;
  totalEvents: number;
  lastMaintenanceDate?: string;
  nextScheduledDate?: string;
}

export interface MaintenanceFilters {
  assetId?: string;
  maintenanceTypes?: MaintenanceType[];
  dateFrom?: string;
  dateTo?: string;
  costMin?: number;
  costMax?: number;
  supplierName?: string;
  warrantyWork?: boolean;
  pageNumber?: number;
  pageSize?: number;
  sortBy?: string;
  sortDirection?: 'asc' | 'desc';
}
